import {
  CreateFacturaRequestSchema,
  EnviarFacturaEmailResponseSchema,
  EstadoSifenResponseSchema,
  FacturaListQuerySchema,
  FacturaSchema,
} from '@visep/shared-types/facturas';
import type {
  CreateFacturaRequest,
  EnviarFacturaEmailRequest,
  EnviarFacturaEmailResponse,
  EstadoSifenResponse,
  Factura,
  FacturaListQuery,
} from '@visep/shared-types/facturas';
import type { Helpers, ListResult } from './internal.js';
import { listResultSchema, toQuery } from './internal.js';

export function createFacturasResource({ request, requestBlob }: Helpers) {
  return {
    async list(query?: FacturaListQuery): Promise<ListResult<Factura>> {
      const parsed = FacturaListQuerySchema.parse(query ?? {});
      return listResultSchema(FacturaSchema).parse(await request('GET', `/api/facturas${toQuery(parsed)}`));
    },
    async get(id: string): Promise<Factura> {
      return FacturaSchema.parse(await request('GET', `/api/facturas/${encodeURIComponent(id)}`));
    },
    async create(input: CreateFacturaRequest): Promise<Factura> {
      const parsed = CreateFacturaRequestSchema.parse(input);
      return FacturaSchema.parse(await request('POST', '/api/facturas', parsed));
    },
    async emitir(id: string): Promise<Factura> {
      return FacturaSchema.parse(await request('POST', `/api/facturas/${encodeURIComponent(id)}/emitir`));
    },
    async reemitir(id: string, body?: { confirmarPosibleDuplicado?: boolean }): Promise<Factura> {
      return FacturaSchema.parse(
        await request('POST', `/api/facturas/${encodeURIComponent(id)}/reemitir`, body ?? {}),
      );
    },
    async sendEmail(id: string, input?: EnviarFacturaEmailRequest): Promise<EnviarFacturaEmailResponse> {
      return EnviarFacturaEmailResponseSchema.parse(
        await request('POST', `/api/facturas/${encodeURIComponent(id)}/email`, input ?? {}),
      );
    },
    async getKude(id: string): Promise<Blob> {
      return requestBlob(`/api/facturas/${encodeURIComponent(id)}/kude`);
    },
    async estadoSifen(id: string): Promise<EstadoSifenResponse> {
      return EstadoSifenResponseSchema.parse(
        await request('GET', `/api/facturas/${encodeURIComponent(id)}/estado-sifen`),
      );
    },
  };
}
